/* eslint-disable comma-dangle */
/* eslint-disable indent */
import "./app/publicPath";
// =========================
// Polyfill's
// =========================
import "custom-event-polyfill";

// =========================
// Framework's
// =========================
import Vue from "vue";
import Vuex from "vuex";
import { mount } from "./mount";

Vue.prototype.$mount = mount;

window.Vue = Vue;
window.Vuex = Vuex;

import script2 from "./app/plugins/script2";
Vue.use(script2);

import "./app/jQuery";

import "bootstrap";

import { getUrlParams } from "./app/services/UrlService";
window.ceresEnv = getUrlParams()["env"];

import LazyHydrate from "vue-lazy-hydration";

// =========================
// COMPONENTS
// =========================
Vue.component("lazy-hydrate", LazyHydrate);
Vue.component("add-item-to-basket-overlay", () =>
  import("./app/components/basket/AddItemToBasketOverlay.vue")
);
Vue.component("add-to-basket", () =>
  import("./app/components/basket/AddToBasket.vue")
);
Vue.component("basket-preview", () =>
  import("./app/components/basket/BasketPreview.vue")
);
Vue.component("basket-totals", () =>
  import("./app/components/basket/BasketTotals.vue")
);
Vue.component("mail-changed-info", () =>
  import("./app/components/basket/MailChangedInfo.vue")
);
Vue.component("coupon", () => import("./app/components/basket/Coupon.vue"));
Vue.component("basket-list", () =>
  import("./app/components/basket/list/BasketList.vue")
);
Vue.component("lazy-img", () => import("./app/components/common/LazyImg.vue"));

Vue.component("intersect", () =>
  import("./app/components/common/Intersect.vue")
);
Vue.component("change-email-form", () =>
  import("./app/components/customer/ChangeEmailForm.vue")
);
Vue.component("recaptcha", () =>
  import("./app/components/customer/ReCaptcha.vue")
);
Vue.component("registration", () =>
  import("./app/components/customer/Registration.vue")
);
Vue.component("reset-password-form", () =>
  import("./app/components/customer/ResetPasswordForm.vue")
);
Vue.component("forgot-password-modal", () =>
  import("./app/components/customer/login/ForgotPassword.vue")
);

// legacy non-shopbuilder component
Vue.component("login-view", () =>
  import("./app/components/customer/login/LoginView.vue")
);
Vue.component("item-bundle", () =>
  import("./app/components/item/ItemBundle.vue")
);
Vue.component("order-property-value", () =>
  import("./app/components/item/OrderPropertyValue.vue")
);
Vue.component("quantity-input", () =>
  import("./app/components/item/QuantityInput.vue")
);
Vue.component("search-item", () =>
  import("./app/components/itemList/SearchItem.vue")
);
Vue.component("newsletter-input", () =>
  import("./app/components/newsletter/NewsletterInput.vue")
);
Vue.component("order-return", () =>
  import("./app/components/orderReturn/OrderReturn.vue")
);
Vue.component("icon", () => import("./app/components/pageDesign/Icon.vue"));
Vue.component("notifications", () =>
  import("./app/components/pageDesign/Notifications.vue")
);
Vue.component("cookie-bar", () =>
  import("./app/components/pageDesign/CookieBar.vue")
);
Vue.component("popper", () => import("./app/components/pageDesign/Popper.vue"));
Vue.component("loading-animation", () =>
  import("./app/components/pageDesign/LoadingAnimation.vue")
);
Vue.component("navigation", () =>
  import("./app/components/pageDesign/Navigation.vue")
);
Vue.component("wish-list", () =>
  import("./app/components/wishList/WishList.vue")
);
Vue.component("wish-list-count", () =>
  import("./app/components/wishList/WishListCount.vue")
);
Vue.component("lazy-load", () =>
  import("./app/components/common/LazyLoad.vue")
);
Vue.component("add-to-wish-list", () =>
  import("./app/components/item/AddToWishList.vue")
);
Vue.component("item-filter-list", () =>
  import("./app/components/itemList/filter/ItemFilterList.vue")
);
Vue.component("item-filter-tag-list", () =>
  import("./app/components/itemList/filter/ItemFilterTagList.vue")
);
Vue.component("single-item", () =>
  import("./app/components/item/SingleItem.vue")
);

// =========================
// DIRECTIVES
// =========================
import "./app/directives/basket/toggleBasketPreview";
import "./app/directives/basket/basketItemCount";
import "./app/directives/common/truncateTooltip";
import "./app/directives/customer/logout";
import "./app/directives/helper/testingAttr";
import "./app/directives/helper/populateStore";
import "./app/directives/helper/validate";
import "./app/directives/pageDesign/tooltip";
import "./app/directives/pageDesign/lazyloadImg";

// =========================
// FILTERS
// =========================
import "./app/filters/ageRestriction.filter";
import "./app/filters/arrayFirst.filter";
import "./app/filters/attachText.filter";
import "./app/filters/currency.filter";
import "./app/filters/date.filter";
import "./app/filters/fileName.filter";
import "./app/filters/fileUploadPath.filter";
import "./app/filters/graduatedPrice.filter";
import "./app/filters/hasItemDefaultPrice.filter";
import "./app/filters/inputUnit.filter";
import "./app/filters/itemBundleName.filter";
import "./app/filters/itemCrossPrice.filter";
import "./app/filters/itemImage.filter";
import "./app/filters/itemImageAlternativeText.filter";
import "./app/filters/itemImages.filter";
import "./app/filters/itemName.filter";
import "./app/filters/itemPrice.filter";
import "./app/filters/itemUrl.filter";
import "./app/filters/numberFormat.filter";
import "./app/filters/propertySurcharge.filter";
import "./app/filters/propertyFileUrl.filter";
import "./app/filters/translate.filter";
import "./app/filters/truncate.filter";

// =========================
// MIXINS
// =========================
import "./app/mixins/getJsonData.mixin";
import "./app/mixins/template.mixin";

// =========================
// Bootstrap frameworks
// =========================
import "./app/main";

import TranslationService from "./app/services/TranslationService";
import {
  createStore,
  initClientListeners,
  initClientStore,
  initServerStore,
} from "./app/store";
import { initListener } from "./app/services/ApiService";

window.ceresTranslate = TranslationService.translate;

Vue.prototype.$translate = TranslationService.translate;
Vue.prototype.$ceres = App;

const store = createStore();

window.ceresStore = store;

initServerStore(store);
initClientStore(store);
initClientListeners(store);
initListener();
